var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"animated-n"},[_vm._v(_vm._s(_vm.formattedDisplayValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }